import { render, staticRenderFns } from "./PricesImportDialog.vue?vue&type=template&id=2317f5e3"
import script from "./PricesImportDialog.vue?vue&type=script&lang=js"
export * from "./PricesImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports